export default function LogoMark({ size = 36, inverse = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="30" stroke={inverse ? "#d2f58b" : "#113d40"} strokeWidth="3" fill="transparent" />
      <g stroke={inverse ? "#d2f58b" : "#113d40"} strokeWidth="5.5" strokeLinecap="round">
        <line x1="32" y1="13" x2="32" y2="51" />
        <line x1="13" y1="32" x2="51" y2="32" />
        <line x1="19" y1="19" x2="45" y2="45" />
        <line x1="45" y1="19" x2="19" y2="45" />
      </g>
      <circle cx="32" cy="32" r="6.5" fill={inverse ? "#d2f58b" : "#113d40"} stroke="#f7f8f2" strokeWidth="2.5" />
    </svg>
  );
}
